export const vendorPageRouteName = "/master-data/vendor";
export const addVendorPageRouteName = "/master-data/vendor/add";
export const editVendorPageRouteName = (id?: string) => `/master-data/vendor/edit/${id ?? ":id"}`;
export const draftVendorPageRouteName = "/master-data/vendor/draft";
